// Shared pending count + invalidation listeners (WS-driven, no polling)

import { fetchInternalApplications } from '../pages/private/admin/organisationMembersTabs/internalApplications/internalApplicationsApi';

let pendingCount = 0;
let pendingFetchPromise = null;
const countSubscribers = new Set();
const invalidateSubscribers = new Set();

const notifyCount = () => {
  countSubscribers.forEach((cb) => cb());
};

const notifyInvalidate = () => {
  invalidateSubscribers.forEach((cb) => cb());
};

export function getPendingInternalApplicationsCount() {
  return pendingCount;
}

export function setPendingInternalApplicationsCount(next) {
  const value = Math.max(0, Number(next) || 0);
  if (value === pendingCount) return;
  pendingCount = value;
  notifyCount();
}

/** Sync badge from list response counts (no extra HTTP). */
export function syncInternalApplicationsPendingFromListCounts(counts) {
  if (counts && typeof counts.pending === 'number') {
    setPendingInternalApplicationsCount(counts.pending);
  }
}

export function subscribePendingInternalApplicationsCount(cb) {
  countSubscribers.add(cb);
  return () => countSubscribers.delete(cb);
}

export function subscribeInternalApplicationsInvalidate(cb) {
  invalidateSubscribers.add(cb);
  return () => invalidateSubscribers.delete(cb);
}

export function invalidateInternalApplicationsList() {
  notifyInvalidate();
}

/** Single in-flight pending fetch (dedupes Strict Mode + parallel callers). */
export async function fetchPendingInternalApplicationsCountOnce() {
  if (pendingFetchPromise) {
    return pendingFetchPromise;
  }

  pendingFetchPromise = (async () => {
    try {
      const data = await fetchInternalApplications('pending');
      if (!data?.ok) return pendingCount;

      const next =
        typeof data.counts?.pending === 'number'
          ? data.counts.pending
          : Array.isArray(data.items)
            ? data.items.length
            : 0;

      setPendingInternalApplicationsCount(next);
      return next;
    } catch {
      return pendingCount;
    } finally {
      pendingFetchPromise = null;
    }
  })();

  return pendingFetchPromise;
}
